/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseOwnerResponseAccountInformation } from './CaseOwnerResponseAccountInformation';
import {
    CaseOwnerResponseAccountInformationFromJSON,
    CaseOwnerResponseAccountInformationFromJSONTyped,
    CaseOwnerResponseAccountInformationToJSON,
    CaseOwnerResponseAccountInformationToJSONTyped,
} from './CaseOwnerResponseAccountInformation';
import type { CaseOwnerResponsePartnerInformation } from './CaseOwnerResponsePartnerInformation';
import {
    CaseOwnerResponsePartnerInformationFromJSON,
    CaseOwnerResponsePartnerInformationFromJSONTyped,
    CaseOwnerResponsePartnerInformationToJSON,
    CaseOwnerResponsePartnerInformationToJSONTyped,
} from './CaseOwnerResponsePartnerInformation';

/**
 * 
 * @export
 * @interface CaseOwnerResponse
 */
export interface CaseOwnerResponse {
    /**
     * 
     * @type {CaseOwnerResponseAccountInformation}
     * @memberof CaseOwnerResponse
     */
    accountInformation?: CaseOwnerResponseAccountInformation;
    /**
     * 
     * @type {CaseOwnerResponsePartnerInformation}
     * @memberof CaseOwnerResponse
     */
    partnerInformation?: CaseOwnerResponsePartnerInformation;
}

/**
 * Check if a given object implements the CaseOwnerResponse interface.
 */
export function instanceOfCaseOwnerResponse(value: object): value is CaseOwnerResponse {
    return true;
}

export function CaseOwnerResponseFromJSON(json: any): CaseOwnerResponse {
    return CaseOwnerResponseFromJSONTyped(json, false);
}

export function CaseOwnerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseOwnerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accountInformation': json['accountInformation'] == null ? undefined : CaseOwnerResponseAccountInformationFromJSON(json['accountInformation']),
        'partnerInformation': json['partnerInformation'] == null ? undefined : CaseOwnerResponsePartnerInformationFromJSON(json['partnerInformation']),
    };
}

export function CaseOwnerResponseToJSON(json: any): CaseOwnerResponse {
    return CaseOwnerResponseToJSONTyped(json, false);
}

export function CaseOwnerResponseToJSONTyped(value?: CaseOwnerResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountInformation': CaseOwnerResponseAccountInformationToJSON(value['accountInformation']),
        'partnerInformation': CaseOwnerResponsePartnerInformationToJSON(value['partnerInformation']),
    };
}

